import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'
import { ListaVideosDrop } from '../components/listaVideosDrop'

const { v4: uuidv4 } = require('uuid');



const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
  
        title, 
        html, 
        icon, 
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',  
        showCancelButton: true, 
        cancelButtonColor: '#d33',  
        cancelButtonText: 'Cancelar' 
    }) 
}




export const ListaVideos =  () => {

    const [ isLoading, setIsLoading ] = useState(false);
    const [items, setItems] = useState([]);

    const { socket } = useContext( SocketContext );

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();
    
    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate ])

    useHideMenu(false);
    

    
    
    useEffect(() => {
        async function fetchData() {

            socket.emit('lista-videos', {entidad, pantalla:'principal'}, ( lista ) => {
               
                setItems( JSON.parse(lista[0].listaVideos) )
            })
        }

        fetchData();
        return () => {
            socket.off('lista-videos')
        }
    }, [])

    // useEffect(() => {
      
    //     async function fetchData() {
    //         await socket.on('videos-listas', ( lista ) => {
    //             console.log(lista);
    //             setData( lista )
    //         })
    //     }

    //     fetchData();

    //     return () => {
    //         socket.off('videos-listas')
    //     }
    // }, [])




    const handleInputChange = async(ev, campo, itemId) => {

        const valor= ev.target.value;
        const valorAnterior=  ev.target.defaultValue;
       
        if ( valor === valorAnterior ) return false; 
        
        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Modificar el registro?", "warning" );
        if (!confirmacion.value){
            ev.target.value = valorAnterior;
            return false;
        }
    


        const updatedItems = items.map(item => {
            if (item.id === itemId) {
                return { ...item, [campo]: ev.target.value };
            }
            return item;
        });
        setItems(updatedItems);

        registraCambios(ev, 'principal' , updatedItems);
    
    };



    const onDragEnd = (result) => {
            if (!result.destination) return; // Si el elemento no se soltó en un destino válido, no hagas nada

            const updatedItems = Array.from(items);
            const [removed] = updatedItems.splice(result.source.index, 1); // Elimina el elemento de la posición de origen
            updatedItems.splice(result.destination.index, 0, removed); // Inserta el elemento en la posición de destino

            setItems(updatedItems);

            registraCambios('', 'principal' , updatedItems);
    
    };

    const registraItem = async ( ) => {

        const id= uuidv4();

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        
        const code   = document.getElementById(`videoCodigo_`).value;
        const title   = document.getElementById(`videoTitulo_`).value;
        

       
        const registros = document.querySelectorAll('.registro');
        
        registros.forEach((elemento, index) => {
            if( elemento.value === "" ) return sweet('Atención!', 'Revise la información', 'error');
            if( elemento.value < 0    ) return sweet('Atención!', 'Revise la información', 'error');
        });

        const updatedItems = Array.from(items);
        updatedItems.push({ id, title, code }); // Inserta el elemento en la posición de destino
        setItems(updatedItems);

        socket.emit( 'actualiza-Videos', {entidad, pantalla:'principal', updatedItems }, ( res ) => {
            setIsLoading(false)
            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                })   
            }else{
                console.log(res);
            }


        })
        

        
        
        // setIsLoading(true)
        // socket.emit( 'registra-Video', datos, async ( res ) => {
        //     setIsLoading(false)

        //     if( res[0] === ""){
        //         sweet('Atención!', res[1], 'error');
        //     }else if( res[0] === 1){
        //         sweet('', res[1], 'success');
                
        //         registros.forEach((elemento, index) => {
        //             if( elemento.type !== "checkbox" ) elemento.value = ""
        //             else elemento.checked= false;
        //             delete datos[elemento.id.split("_")[0]];
        //         })   
        //     }else{
        //         console.log(res);
        //     }

          

        // })

        

    }
    

    const deleteItem = async(id) =>{
        console.log(id);

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Eliminar el registro?", "warning" );
        if (!confirmacion.value){
            return false;
        }

        const updatedItems = items.filter(item => item.id !== id)
        console.log(updatedItems);

        setItems(updatedItems);

        registraCambios('', 'principal' , updatedItems);
    } 

    const registraCambios =  async (ev, pantalla , updatedItems) =>{

        setIsLoading(true)
        await socket.emit( 'actualiza-Videos', {entidad, pantalla, updatedItems }, ( res ) => {
            setIsLoading(false)

            console.log(res);
            if( res === null){
                
                sweet('Atención!', 'Contacte al Administrador', 'error');
                if(ev != '') ev.target.value = ev.target.defaultValue;

            }else if( res[0] === ""){
                
                sweet('Atención!', res[1], 'error');
                if(ev != '') ev.target.value = ev.target.defaultValue;

            }else if( res[0] === "E"){
                sweet('Atención!', 'Contacte al Administrador', 'error');
                if(ev != '') ev.target.value = ev.target.defaultValue;
            }


        })
        
        
    }


    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("videoslistas") ) {
        return( <NoAcceso /> )
    } 
    else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>

                    <div className='row'>
                        <div className='col-lg-2 col-12 '>
                            <button
                                className='btn btn-success m-3'
                                data-bs-toggle="collapse" 
                                data-bs-target="#divAgregaVideo"
                            >
                            Agregar Video
                            </button> 
                            
                        </div>
                    </div>

                    <div id='divAgregaVideo'  className='row border border-info rounded shadow p-3 collapse hide'>
                        <Table responsive="md" striped hover style={{minWidth: 300}} className='max400' >
                            <thead>
                                <tr >
                                    <th width={'5%'}></th>
                                    <th width={'50%'}>Título</th>
                                    <th width={'45%'}>Código</th>
                                    
                                </tr>
                            </thead>
                            <tbody   >

                                <tr style={{minHeight: 50}}>
                                    <td width={'5%'}>
                                        <button
                                            className='btn btn-sm btn-primary me-1'
                                            onClick={ ()=> registraItem() }
                                        > 
                                        <i className='fas fa-save'></i>
                                        </button> 

                                    </td>

                                    <td width={'50%'}> 
                                        <input
                                            type='text'
                                            className='form-control registro'
                                            id='videoTitulo_'
                                        />

                                    </td>


                                    <td width={'45%'}> 
                                        <input
                                            type='text'
                                            className='form-control registro'
                                            id='videoCodigo_'
                                        />
                                    </td>
                                    
                                    
                                </tr>
                            
                            </tbody>
                        </Table>

                    </div>

                    <hr />




                    {/* <h1>Lista De Videos en la Pantalla Principal </h1> */}
                    <ListaVideosDrop items={items} onDragEnd={onDragEnd} handleInputChange={handleInputChange} deleteItem={deleteItem} />

                </div>

            </>
        );
    }

}